import {
	AttachmentCategory,
	ATTACHMENT_CATEGORY_OTHER,
	ATTACHMENT_CATEGORY_SOIL,
	ATTACHMENT_CATEGORY_WATER,
	ATTACHMENT_CATEGORY_WEBFORM,
	GuaranteeStatus
} from '../../../models/guarantee-constants';
import { Guarantee } from '../../../models/guarantee';
import { GuaranteeRequestAttachment } from '../../../models/guarantee-request-attachment';

export class GuaranteeRequestAttachmentEditor {
	updating = false;

	getCategory(attachment: GuaranteeRequestAttachment): AttachmentCategory {
		const value = attachment.metaData.type;
		if (value === ATTACHMENT_CATEGORY_SOIL) {
			return ATTACHMENT_CATEGORY_SOIL;
		}
		return value === ATTACHMENT_CATEGORY_WATER ? ATTACHMENT_CATEGORY_WATER : ATTACHMENT_CATEGORY_OTHER;
	}

	demoteCategoryToOther(
		guarantee: Guarantee,
		attachments: GuaranteeRequestAttachment[],
		category: typeof ATTACHMENT_CATEGORY_SOIL | typeof ATTACHMENT_CATEGORY_WATER
	) {
		const affectedAttachments = attachments
			.filter(attachment => this.getCategory(attachment) === category);
		for (const attachment of affectedAttachments) {
			this.setCategory(guarantee, attachment, ATTACHMENT_CATEGORY_OTHER);
		}
	}

	isCategoryEditable(attachment: GuaranteeRequestAttachment, guarantee: Guarantee): boolean {
		if (attachment.metaData.type === ATTACHMENT_CATEGORY_WEBFORM) {
			return false;
		}
		return !attachment.chronicleId || guarantee.status === GuaranteeStatus.DRAFT;
	}

	setCategory(
		_guarantee: Guarantee,
		attachment: GuaranteeRequestAttachment,
		category: AttachmentCategory
	) {
		if (attachment.metaData.type === category) {
			return;
		}
		attachment.metaData.type = category;
	}
}
